import { ListWidgetService } from "./service.listwidgets";
import { ListItems } from "./service.listwidgets";
import { VersionCheck } from "./service.versioncheck";
import { Utility } from "./utility";
import * as angular from "angular";

require("../css/materialicons.css");
require("materialize-css/bin/materialize.css");
require("../css/main.css");
require("materialize-css/bin/materialize.js");
require("angular-drag-and-drop-lists/angular-drag-and-drop-lists.js");

var app = angular.module("IADOT", ['ngRoute', 'dndLists'])
.config(['$locationProvider', function($locationProvider) {
    $locationProvider.html5Mode({ enabled: true, requireBase: false });
 }])
;

export default app;

app.service('ListWidgetService', ListWidgetService);

class ListController {
    public static AngularDependencies = ['$scope', "$http", '$routeParams', '$rootScope', '$timeout', 'ListWidgetService', ListController];

    public list_items: ListItems[] = [];

    static $inject = ['$scope', '$http', '$routeParams', '$rootScope','ListWidgetService'];

    public savethis = function () {
        this.ListWidgetService.save(this.list_items);
    };
    public timeout;
    public refreshPage = function(index){
        if(index != -1){
            this.list_items.splice(index,1)
        }

        this.timeout(() => {
            WebSocket.Update(null);
        });
    }

    public toggleWidgetShow = function(x,state){
        x.show = !state;
        this.refreshPage(-1);
    }

    constructor($scope: angular.IScope, $http, $routeParams, $rootScope, $timeout, public ListWidgetService: ListWidgetService) {
        this.list_items = ListWidgetService.getdata();
        let vm = this;
        this.timeout = $timeout;
        $scope.$on("list_changed", function (event) {
            vm.list_items = ListWidgetService.getdata();
            $scope.$apply();
        });
    }
}

app.controller('ListController', ListController.AngularDependencies);
app.controller('bottlenecksController', bottlenecksController.AngularDependencies);
app.controller('constructionController', constructionController.AngularDependencies);
app.controller('incidentsController', incidentsController.AngularDependencies);
app.controller('incidentsByTypeController', incidentsByTypeController.AngularDependencies);
app.controller('inspectionsByTypeController', inspectionsByTypeController.AngularDependencies);
app.controller('workzonesController', workzonesController.AngularDependencies);
app.controller('roadConditionsController', roadConditionsController.AngularDependencies);
app.controller('winterclosuresController', winterclosuresController.AngularDependencies);
app.controller('floodingController', floodingController.AngularDependencies);
app.controller('waittimesController', waittimesController.AngularDependencies);

import incidentsController from './incidents/controller.incidents';
import winterclosuresController from './winterclosures/controller.winterclosures';
import floodingController from './flooding/controller.flooding';
import incidentsByTypeController from './incidentsbytype/controller.incidentsbytype';
import inspectionsByTypeController from './inspectionsbytype/controller.inspectionsbytype';
import workzonesController from './workzones/controller.workzones';
import bottlenecksController from './bottlenecks/controller.bottlenecks';
import constructionController from './construction/controller.construction';
import roadConditionsController from './roadconditions/controller.roadconditions';
import waittimesController from './waittimes/controller.waittimes';

import './listitems/template.listitem.html';
import ListItem from './listitems/directive.listitem';
import './incidentsbytype/template.incidentsbytype.html';
import IncidentsByType from './incidentsbytype/directive.incidentsbytype';
import './workzones/template.workzones.html';
import WorkZones from './workzones/directive.workzones';
import './roadconditions/template.roadconditions.html';
import RoadConditions from './roadconditions/directive.roadconditions';
import './incidents/template.incidents.html';
import Incidents from './incidents/directive.incidents';
import './winterclosures/template.winterclosures.html';
import Winterclosures from './winterclosures/directive.winterclosures';
import './flooding/template.flooding.html';
import Flooding from './flooding/directive.flooding';
import './bottlenecks/template.bottlenecks.html';
import Bottlenecks from './bottlenecks/directive.bottlenecks';
import './construction/template.construction.html';
import Construction from './construction/directive.construction';
import './waittimes/template.waittimes.html';
import WaitTimes from './waittimes/directive.waittimes';
import mytooltip from './tooltip/directive.tooltip';
import './inspectionsbytype/template.inspectionsbytype.html'
import InspectionsByType from "./inspectionsbytype/directive.inspectionsbytype";
import { WebSocket } from "./websocket";

app.directive('listItem', ListItem.Factory());
app.directive('incidents', Incidents.Factory());
app.directive('winterclosures', Winterclosures.Factory());
app.directive('flooding', Flooding.Factory());
app.directive('incidentsbytype', IncidentsByType.Factory());
app.directive('inspectionsbytype', InspectionsByType.Factory());
app.directive('workzones', WorkZones.Factory());
app.directive('bottlenecks', Bottlenecks.Factory());
app.directive('construction', Construction.Factory());
app.directive('roadconditions', RoadConditions.Factory());
app.directive('waittimes', WaitTimes.Factory());
app.directive('mytooltip', mytooltip.Factory());

app.config(function ($routeProvider) {
    $routeProvider
        .when('/', {
            template: require('../pages/list.html'),
            controller: "ListController",
            controllerAs: "list"
        })
        .otherwise({
            redirectTo: '/'
        });
});

// Start the version check service.
new VersionCheck().Start();
var webSocket = new WebSocket();

// Collapse and configure the side navigation.
$(document).ready(function () {

    var action: string;
    var timer:any = null;

    (<any>$(".button-collapse")).sideNav();

    hideTag();

    /* close side nav when mouse leaves the app */
    $(document).mouseleave(function(e){
        closeSideNav();
    });

    /* show tag and start fade out timer when mouse moves
      anywhere in the document except when its over the tag */
    $(document).mousemove(function(e){
      var mouse_on_tag_data = $("#side-nav-tag:hover").length;
      if(mouse_on_tag_data != 1){
        showTag();
        if(timer != null){
          clearTimeout(timer);
        }
        timer = setTimeout(hideTag, 1500);
      }
    });

    /* open the side nav when tag is clicked */
    $("#side-nav-tag").click(function(e){
      openSideNav()
    });

    /* clear fade out timer for tag when mouse hovers over it */
    $("#side-nav-tag").mouseenter(function(e){
      clearTimeout(timer);
      showTag();
    });

    /* close the side nav when mouse leaves */
    $('#slide-out').mouseleave(function(e){
      closeSideNav();
    });

    function openSideNav(){
      action = "show";
      (<any>$(".button-collapse")).sideNav(action);
    }

    function closeSideNav(){
      action = "hide";
      (<any>$(".button-collapse")).sideNav(action);
    }

    function showTag(){
      $('#side-nav-tag').stop().fadeIn('fast');
    }

    function hideTag(){
      $('#side-nav-tag').stop().fadeOut('fast');
    }

    $('#scaleFullScreenOption').click(function(e){
        location.href = Utility.updateUrlParameter(location.href, "scale", "100");
    });

    $('#scaleHalfScreenOption').click(function(e){
        location.href = Utility.updateUrlParameter(location.href, "scale", "50");
    });

    $('#scaleDualHalfScreenOption').click(function(e){
        location.href = Utility.updateUrlParameter(location.href, "scale", "50,200");
    });

    webSocket.Start();
});

// Highlight the given preset option.
function HighlightPreset(id: string) {
    $("#" + id).removeClass("highlightable").addClass("transparent_option");
}

// Scale the screen based on query string parameter.
// Parameter specification: scale=percentwidth,percentheight
// Example: scale=50,100
let screenScale = Utility.getQueryVariable("scale");

function UpdateScreenScale(scale: string) {
    let screenWidth, screenHeight = 100;
    let paramScaleValues: string[] = scale.trim().split(/\s*,\s*/);
    if (!isNaN(parseInt(paramScaleValues[0]))) {
        screenWidth = parseInt(paramScaleValues[0]);
    }
    if (!isNaN(parseInt(paramScaleValues[1]))) {
        screenHeight = parseInt(paramScaleValues[1]);
    }

    // Get scaling factor used to transform content.
    let widthScale = 100 / screenWidth;
    let heightScale = 100 / screenHeight;

    // CSS properties to change screen scale.
    let transform = {
        "width": `${screenWidth}%`,
        "height": `${screenHeight}%`,
        "transform": `scale(${widthScale}, ${heightScale})`,
        "transform-origin": "0 0"
    };
    console.log("Transforming screen: ", transform);

    $("#toplevelcontainer").css(transform);

    // highlight current scaling option.
    if (screenWidth == 50 && screenHeight == 200) {
        HighlightPreset("scaleDualHalfScreenOption");
    }
    else if (screenWidth == 50 && screenHeight == 100) {
        HighlightPreset("scaleHalfScreenOption");
    }
    else if (screenWidth == 100 && screenHeight == 100) {
        HighlightPreset("scaleFullScreenOption");
    }
}

if (screenScale) {
    UpdateScreenScale(screenScale);
}
else {
    HighlightPreset("scaleFullScreen");
}



// WEBPACK FOOTER //
// ./src/app/main.ts